import { Injectable } from '@angular/core';
import { RouterStateSnapshot, Router } from '@angular/router';

import { ToastController } from '@ionic/angular';
import { CoreService } from '../services/core.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
      private router: Router,
      private toastController: ToastController,
      private coreService: CoreService,
    ) {}

    canActivate = async () => {
      const navigation = this.router.getCurrentNavigation();
      const state = navigation?.extras.state;

      if(state?.isForEnrolment) {
        return true;
      }
      const user = JSON.parse(localStorage.getItem('user'));
      if (user) {
        return true;
      } else {
        this.router.navigateByUrl('auth', {replaceUrl: true}).then(async () => {
          !environment.production && console.log("Clearing local storage");
          localStorage.clear();
        });
        return false;
      }
    };
}
